<template>
  <article class="cmp cmp-product-thumb p-0" :data-testing="item.variation.id">
    <div :class="paddingClasses" :style="paddingInlineStyles">
      <div class="thumb-image">
        <div class="prop-1-1">
          <slot name="item-image">
            <category-image-carousel
              :image-urls-data="item.images | itemImages(imageUrlAccessor)"
              :alt="item | itemName"
              :title="item | itemName"
              :item-url="item | itemURL(urlWithVariationId)"
              :enable-carousel="$ceres.config.item.enableImageCarousel"
              :disable-carousel-on-mobile="disableCarouselOnMobile"
              ref="categoryImageCarousel"
            >
            </category-image-carousel>
          </slot>
        </div>

        <div class="fs-saving" v-if="savingMoneyPercent > 0">
          <span class="text-white"> -{{ Math.floor(savingMoneyPercent) }}% </span>
        </div>
      </div>

      <!-- STORE SPECIALS -->
      <slot name="store-special">
        <item-store-special
          v-if="storeSpecial || item.variation.bundleType === 'bundle' || item.item.itemType === 'set'"
          :store-special="storeSpecial"
          :recommended-retail-price="item.prices.rrp"
          :variation-retail-price="item.prices.default"
          :special-offer-price="item.prices.specialOffer"
          :decimal-count="decimalCount"
          :bundle-type="item.variation.bundleType"
          :item-type="item.item.itemType"
        >
        </item-store-special>
      </slot>
      <!-- ./STORE SPECIALS -->

      <!-- ITEM DETAILS -->
      <slot name="item-details">
        <div class="thumb-content p-2">
          <a :href="item | itemURL(urlWithVariationId)" class="thumb-title font-weight-bold" :class="{ 'stretched-link': $ceres.config.global.shippingCostsCategoryId == 0 }">
            {{ item | itemName
            }}<!--
                    --><span v-for="attribute in item.groupedAttributes">{{ "Ceres::Template.itemGroupedAttribute" | translate(attribute) }}</span>
          </a>

          <div class="thumb-meta mt-2 d-flex flex-wrap flex-md-nowrap">
            <div class="availability-preview align-self-end small font-weight-bold py-2 pb-md-0">
              <i class="fa fa-circle" aria-hidden="true" :class="'availability-' + item.variation.availability.id"></i>
              <span v-if="item.variation.availability.id == 1" v-html="$translate('ohrensessel::ItemAvailability.Availability1')"></span>
              <span v-if="item.variation.availability.id == 2" v-html="$translate('ohrensessel::ItemAvailability.Availability2')"></span>
              <span v-if="item.variation.availability.id == 3" v-html="$translate('ohrensessel::ItemAvailability.Availability3')"></span>
              <span v-if="item.variation.availability.id == 4" v-html="$translate('ohrensessel::ItemAvailability.Availability4')"></span>
              <span v-if="item.variation.availability.id == 5" v-html="$translate('ohrensessel::ItemAvailability.Availability5')"></span>
              <span v-if="item.variation.availability.id == 6" v-html="$translate('ohrensessel::ItemAvailability.Availability6')"></span>
              <span v-if="item.variation.availability.id == 7" v-html="$translate('ohrensessel::ItemAvailability.Availability7')"></span>
              <span v-if="item.variation.availability.id == 8" v-html="$translate('ohrensessel::ItemAvailability.Availability8')"></span>
              <span v-if="item.variation.availability.id == 9" v-html="$translate('ohrensessel::ItemAvailability.Availability9')"></span>
              <span v-if="item.variation.availability.id == 10" v-html="$translate('ohrensessel::ItemAvailability.Availability10')"></span>
            </div>
            <slot name="before-prices"></slot>

            <div class="prices flex-md-column align-items-center align-items-md-end">
              <div v-if="item.prices.rrp && item.prices.rrp.price.value > 0 && item.prices.rrp.price.value > item.prices.default.price.value" class="price-view-port">
                <del class="crossprice" v-if="item.prices.specialOffer">
                  {{ item.prices.default.unitPrice.formatted | itemCrossPrice(true) }}
                </del>
                <del class="crossprice" v-else>
                  {{ item.prices.rrp.unitPrice.formatted | itemCrossPrice }}
                </del>
              </div>

              <div class="price">
                <template v-if="item.item.itemType === 'set'">
                  {{ $translate("Ceres::Template.itemSetPrice", { price: itemSetPrice }) }}
                </template>
                <template v-else-if="itemGraduatedPriceisCheapestSorting">
                  {{ $translate("Ceres::Template.itemFromPrice", { price: itemPriceGraduated }) }}
                </template>
                <template v-else-if="itemGraduatedPricesalableVariationCount">
                  {{ $translate("Ceres::Template.itemFromPrice", { price: itemPriceGraduated }) }}
                </template>
                <template v-else>
                  {{ item.prices.default.unitPrice.formatted | specialOffer(item.prices, "unitPrice", "formatted") }}
                </template>
              </div>
            </div>
          </div>

          <slot name="after-prices"></slot>

          <template v-for="propertyGroups in item.variationProperties" v-if="item.variationProperties && propertyGroups.id == 19">
            <span
              v-for="(property, index) in propertyGroups.properties"
              class="add-text d-inline-block small font-weight-bold p-2 my-2"
              v-if="property.id == 109"
              v-html="property.values.value"
            ></span>
          </template>

          <template v-for="propertyGroups in item.variationProperties" v-if="item.variationProperties && propertyGroups.id == 19">
            <span
              v-for="(property, index) in propertyGroups.properties"
              class="add-text d-inline-block small font-weight-bold p-2 mb-2"
              v-if="property.id == 111"
              v-html="property.values.value"
            ></span>
          </template>
        </div>
      </slot>
      <!-- ./ITEM DETAILS  -->
    </div>
  </article>
</template>

<script>
import { mapState } from "vuex";
import CategoryImageCarousel from "./CategoryImageCarousel.vue";
import ItemStoreSpecial from "./ItemStoreSpecial.vue";
import { getSlotData } from "../../helper/getSlotData";

export default {
  components: {
    CategoryImageCarousel,
    ItemStoreSpecial,
  },

  props: {
    decimalCount: {
      type: Number,
      default: 0,
    },
    imageUrlAccessor: {
      type: String,
      default: "urlMiddle",
    },
    itemData: {
      type: Object,
    },
    disableCarouselOnMobile: {
      type: Boolean,
    },
    paddingClasses: {
      type: String,
      default: null,
    },
    paddingInlineStyles: {
      type: String,
      default: null,
    },
    forceUrlWithVariationId: {
      type: Boolean,
      default: false,
    },
  },

  jsonDataFields: ["itemDataRef"],

  computed: {
    item() {
      return this.itemData || this.itemSlotData || this.itemDataRef;
    },

    itemSlotData: getSlotData("item-data"),

    savingMoneyPercent() {
      const hasPrice = !!this.item.prices.rrp && ((this.item.prices.rrp.unitPrice.value - this.item.prices.default.price.value) / this.item.prices.rrp.unitPrice.value) * 100;
      return hasPrice;
    },

    /**
     * returns itemData.item.storeSpecial
     */
    storeSpecial() {
      return this.item.item.storeSpecial;
    },

    /**
     * returns itemData.texts
     */
    texts() {
      return this.item.texts;
    },

    itemPrice() {
      return this.$options.filters.specialOffer(this.item.prices.default.unitPrice.formatted, this.item.prices, "unitPrice", "formatted");
    },

    basePrice() {
      return this.item.prices.default.basePrice;
    },

    itemPriceGraduated() {
      let unitPrice;
      if (App.config.item.enableGraduatedPrices) {
        unitPrice = this.item.prices.graduatedPrices.length > 0 ? this.item.prices.graduatedPrices[0].unitPrice : this.item.prices.default.unitPrice;
      } else {
        unitPrice = this.item.prices.default.unitPrice;
      }

      return this.$options.filters.specialOffer(unitPrice.formatted, this.item.prices, "unitPrice", "formatted");
    },

    itemGraduatedPriceisCheapestSorting() {
      return !!this.item.item && this.item.item.salableVariationCount > 1 && !!this.$ceres.isCheapestSorting;
    },

    itemGraduatedPricesalableVariationCount() {
      return !!this.item.item && this.item.item.salableVariationCount == 1 && this.item.prices.graduatedPrices.length > 1 && App.config.item.enableGraduatedPrices;
    },

    itemSetPrice() {
      return this.$options.filters.currency(this.item.prices.default.price.value, this.item.prices.default.currency);
    },

    urlWithVariationId() {
      return !this.$ceres.config.item.showPleaseSelect || this.$ceres.initialPleaseSelect == 0 || this.forceUrlWithVariationId;
    },

    hasCrossPrice() {
      const hasRrpPrice = !!this.item.prices.rrp && this.item.prices.rrp.unitPrice.value > this.item.prices.default.unitPrice.value;

      const hasBeforePrice = !!this.item.prices.specialOffer && !!this.item.prices.default && this.item.prices.default.unitPrice.value > this.item.prices.specialOffer.unitPrice.value;

      return hasRrpPrice || hasBeforePrice;
    },

    ...mapState({
      showNetPrices: (state) => state.basket.showNetPrices,
    }),
  },
};
</script>
